<script setup lang="ts">
import { getCurrentInstance, onUnmounted, ref, watch } from 'vue';
import { setUiScope } from 'vince-ui/composables/useUiScope';

const TAB_SCOPE_PREFIX = 'tab:';

const props = defineProps<{
    value: string | number;
}>();

const emit = defineEmits<{
    'update:value': [value: string | number];
}>();

const instance = getCurrentInstance();
const scopeKey = `${TAB_SCOPE_PREFIX}${instance?.uid}`;

const currentTab = ref<string | number | undefined>(props.value);

const scopeValueFor = (tab: string | number | undefined): string | null => {
    return tab === undefined || tab === null || tab === '' ? null : `${TAB_SCOPE_PREFIX}${tab}`;
};

const trackTabSelection = (tab: string | number) => {
    currentTab.value = tab;
    emit('update:value', tab);
};

watch(() => props.value, (tab) => {
    currentTab.value = tab;
});

watch(currentTab, (tab) => {
    setUiScope(scopeKey, scopeValueFor(tab));
}, { immediate: true });

onUnmounted(() => {
    setUiScope(scopeKey, null);
});
</script>

<template>
    <VLTabs :value="value" @update:value="trackTabSelection">
        <slot />
    </VLTabs>
</template>
